import { inject } from 'dependable-react';
import { APP_DATA_TOKEN } from '../services/InjectTokens';

export function validateFields(): boolean {
  const appState = inject(APP_DATA_TOKEN);

  return appState.avatars.every((avatar) => avatar.isCompleted);
}

// dodati more magic validaciju
